/**
 * donation-form — the default step flow. SYNC: see ../_SYNC.md.
 *
 * 4 steps (amount / details / payment-review / thankyou). All but thankyou are
 * visible in the progress bar. StepDefinition.label returns an i18n KEY string;
 * StepProgress wraps it with the host vue-i18n.
 *
 * `validate` is the client mirror of the server gate. Every gate routes
 * through the SINGLE source of truth {@link validateDonor} (the line-by-line
 * mirror of the backend SubmitDonationForm + ValidatesSubmissionAgainstDocument
 * validators) + {@link isStepValid}, so the per-step "Continue" gate and the
 * per-field inline errors can never drift from each other. Recurring frequencies
 * stay selectable (validateDonor does NOT block them — the 422
 * Submission.Frequency.NotSupported is surfaced at submit).
 */
import { markRaw } from "vue";
import { validateDonor, isStepValid } from "../composables/useDonorValidation";
import StepAmount from "./StepAmount.vue";
import StepDetails from "./StepDetails.vue";
import StepPayment from "./StepPayment.vue";
import StepThankYou from "./StepThankYou.vue";
export const defaultSteps = [
    {
        id: "amount",
        component: markRaw(StepAmount),
        showInProgress: true,
        label: () => "donationForm.steps.amount",
        validate: (state, c) => isStepValid("amount", validateDonor(state, c.config.document)),
    },
    {
        id: "details",
        component: markRaw(StepDetails),
        showInProgress: true,
        label: () => "donationForm.steps.details",
        validate: (state, c) => isStepValid("details", validateDonor(state, c.config.document)),
    },
    {
        id: "payment",
        component: markRaw(StepPayment),
        showInProgress: true,
        label: () => "donationForm.steps.payment",
        validate: (state, c) => isStepValid("payment", validateDonor(state, c.config.document)),
    },
    {
        id: "thankyou",
        component: markRaw(StepThankYou),
        showInProgress: false,
        isTerminal: true,
    },
];
